import { Post, Get, Patch, Put, Delete, Download, ax } from './http';
import { type } from './interface';
import qs from 'qs';
export namespace Notification {

    /**
    * 通知公告列表
    */
    export var GetPagedList = (query: any): Promise<any> => {
        return Get(`/msls/Notification/GetPagedList?${qs.stringify(query)}`, {});
    };
    /**
    * 通知公告详情
    */
    export var GetNotificationDetail = (id: string): Promise<any> => {
        return Get(`/msls/Notification/GetDetail/${id}`, {});
    };
    /**
    * 添加通知公告
    */
    export var AddNotification = (body: any): Promise<any> => {
        return Post(`/msls/Notification/Add`, body);
    };
    /**
     * 编辑通知公告
     */
    export var EditNotification = (id: string, body: any): Promise<any> => {
        return Put(`/msls/Notification/Edit/${id}`, body);
    };
    /**
    * 删除
    */
    export var DelNotification = (id: string): Promise<any> => {
        return Delete(`/msls/Notification/Delete/${id}`, {});
    };

}

